import request from '@/utils/request'
const apiPath = '/live/liveRewardOrder'
import { downloadBlob } from '@/utils/download'

const liveRewardOrderApi = {
  /**
   * 分页查询【直播打赏订单】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【直播打赏订单】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 管理后台-统计打赏数据
   */
  statistics(query) {
    return request.post(`${apiPath}/getLiveRewardOrderStatistics`, query)
  },
  /**
   * 管理后台-统计打赏数据（新接口）
   */
  listStatistics(query) {
    return request.get(`${apiPath}/tee/listStatistics`, { params: query })
  },
  /**
   * 管理后台-打赏记录导出
   */
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '打赏记录.xlsx'))
  },
  /**
   * 管理后台-打赏记录导出（跳转页面方式）
   */
  exportCourseOrder(query) {
    return request.get(`${apiPath}/exportCourseOrder`, { params: query })
  }
}

export default liveRewardOrderApi




